const LinkArrow = ({ isHover }: { isHover: boolean }) => {
  return (
    <svg
      width="12"
      height="13"
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.52386 10.6514C5.3304 10.6514 5.15927 10.5889 5.01046 10.4639C4.87653 10.325 4.80957 10.1653 4.80957 9.9847C4.80957 9.80414 4.87653 9.64442 5.01046 9.50553L8.09082 6.65137L5.01046 3.7972C4.87653 3.65831 4.80957 3.49859 4.80957 3.31803C4.80957 3.13748 4.87653 2.97776 5.01046 2.83887C5.15927 2.71387 5.3304 2.65137 5.52386 2.65137C5.71731 2.65137 5.88844 2.71387 6.03725 2.83887L9.60868 6.1722C9.74261 6.31109 9.80957 6.47081 9.80957 6.65137C9.80957 6.83192 9.74261 6.99164 9.60868 7.13053L6.03725 10.4639C5.88844 10.5889 5.71731 10.6514 5.52386 10.6514Z"
        fill="#3A3D50"
      />
      <rect
        className="transition ease-in-out"
        width="7.61863"
        height="1.30269"
        rx="0.651346"
        transform="matrix(1 0 0 -1 2.19043 7.30273)"
        fill={isHover ? "#3A3D50" : "transparent"}
      />
    </svg>
  );
};

export default LinkArrow;
